import { combineReducers } from 'redux';
import {
  activeNodeIssuesActionTypes,
  nodeIssueTypesActionTypes
} from './../actions/types';
import {
  cachedRequestByIdReducer,
  reducerById
} from './helpers';
import { createSelector } from 'reselect';
import { values } from 'lodash';

const activeIssues = cachedRequestByIdReducer(
  activeNodeIssuesActionTypes,
  undefined, // use default
  undefined, // use default,
  () => reducerById(activeNodeIssuesActionTypes.success,
    activeNodeIssuesActionTypes.delete)
);
const issueTypes = cachedRequestByIdReducer(nodeIssueTypesActionTypes);

// defines a nested state structure for nodeIssues
const nodeIssues = combineReducers({
  active: activeIssues,
  //inactive: TODO,
  types: issueTypes,
});
export default nodeIssues;

const getNodeIssuesState = state => state.nodeIssues;
export const activeNodeIssuesById = state => getNodeIssuesState(state).active.byId;
export const getActiveNodeIssueById = (state, id) => activeNodeIssuesById(state)[id];

export const getActiveNodeIssues = createSelector(
  getNodeIssuesState,
  (nodeIssues) => values(nodeIssues.active.byId)
);

export const nodeIssueTypesById = state => getNodeIssuesState(state).types.byId;
export const getNodeIssueTypeById = (state, id) => nodeIssueTypesById(state)[id];

export const getNodeIssueTypes = createSelector(
  getNodeIssuesState,
  (nodeIssueTypes) => values(nodeIssueTypes.types.byId)
);


// WEBPACK FOOTER //
// src/reducers/nodeIssues.js